import { validZipCodeRanges } from '@ourbranch/lookups';

export const checkZipCodeRange = (zip, state) => {
  const zipCodeRanges = validZipCodeRanges[state];
  const numericZip = parseInt(zip, 10);
  return zipCodeRanges.some((zipRange) => {
    if (typeof zipRange === 'number') {
      return zipRange === numericZip;
    }
    return numericZip >= zipRange[0] && numericZip <= zipRange[1];
  });
};
